import { Box } from "@mui/material";
import { APP_LOGO_SRC, APP_NAME } from "../config/brand";

/**
 * Maphunziro product logo (PNG from public/logo.png).
 */
export default function AppLogo({ size = 40, alt = APP_NAME, sx = {}, ...rest }) {
    return (
        <Box
            component="img"
            src={APP_LOGO_SRC}
            alt={alt}
            width={size}
            height={size}
            sx={{
                width: size,
                height: size,
                objectFit: "contain",
                display: "block",
                flexShrink: 0,
                ...sx,
            }}
            {...rest}
        />
    );
}
